
import Vue, { PropType } from 'vue';

// Components
import ImportSectionItems from './ImportSectionItems.vue';
import Button from '~/components/builders/Base/Button.vue';

// Services & types
import CandidateService from '~/services/CandidateService';
import { ImportSection, SourceType } from '~/services/types/import';
import {
    anyItemHasAction,
    anyItemHasResolved,
    setAllItemsResolved,
} from '~/utils/candidate/ProfileImportHelper';
import { format } from '~/utils/date-fns';
import { parseISO } from 'date-fns';

export default Vue.extend({
    name: 'ImportBox',
    components: {
        ImportSectionItems,
        Button,
    },
    props: {
        importSection: {
            type: Object as PropType<ImportSection>,
            required: true,
        },
        showImportedMetadata: {
            type: Boolean,
            default: true,
        },
        resultViewOnlyMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            candidateService: new CandidateService(),
        };
    },
    computed: {
        sourceType(): string | null {
            if (this.importSection === null) return null;
            switch (this.importSection.sourceType) {
                case SourceType.LinkedIn:
                    return String(this.$t('profile.import.importPopup.sourceTypeLinkedIn'));
                case SourceType.CV:
                    return String(this.$t('profile.import.importPopup.sourceTypeCV'));
                default:
                    return null;
            }
        },
        importedAt(): string {
            return format(parseISO(this.importSection.createdAt.toString()), 'dd.MM.yyyy hh.mm a');
        },
        sectionResolved(): boolean {
            return anyItemHasResolved(this.importSection.section.items, false) === false;
        },
        anyItemHasAction(): boolean {
            return anyItemHasAction(this.importSection.section.items);
        },
    },
    methods: {
        handleUpdateResolved(value: boolean) {
            setAllItemsResolved(this.importSection.section.items, value);
            this.candidateService
                .updateProfileImportSectionsResolved(
                    this.importSection.id,
                    [this.importSection.section.sectionType],
                    value
                )
                .catch(x => {
                    // Rollback
                    setAllItemsResolved(this.importSection.section.items, !value);
                });
        },
    },
});
